// extracted by mini-css-extract-plugin
export default {"actionGrid":"quick-actions_actionGrid__cU4EC","actionCard":"quick-actions_actionCard__OAVtn","iconBg":"quick-actions_iconBg__9W24D"};